var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.loading
    ? _c(
        "v-card",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c("v-card-subtitle", [_vm._v("Данные пользователя:")]),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-list",
                        [
                          _vm.data.firstName
                            ? _c(
                                "v-list-item",
                                [
                                  _c("v-list-item-content", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          "Фамилия: " + _vm.data.firstName
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.data.lastName
                            ? _c(
                                "v-list-item",
                                [
                                  _c("v-list-item-content", [
                                    _vm._v(
                                      " " +
                                        _vm._s("Имя: " + _vm.data.lastName) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.data.middleName
                            ? _c(
                                "v-list-item",
                                [
                                  _c("v-list-item-content", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          "Отчество: " + _vm.data.middleName
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.data.login
                            ? _c(
                                "v-list-item",
                                [
                                  _c("v-list-item-content", [
                                    _vm._v(
                                      " " +
                                        _vm._s("Логин: " + _vm.data.login) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.data.email
                            ? _c(
                                "v-list-item",
                                [
                                  _c("v-list-item-content", [
                                    _vm._v(
                                      " " +
                                        _vm._s("Email: " + _vm.data.email) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.data.phone
                            ? _c(
                                "v-list-item",
                                [
                                  _c("v-list-item-content", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          "Телефон: " +
                                            _vm.convertToPhone(_vm.data.phone)
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.data.birthday
                            ? _c(
                                "v-list-item",
                                [
                                  _c("v-list-item-content", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          "Дата рождения: " + _vm.data.birthday
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.data.gender
                            ? _c(
                                "v-list-item",
                                [
                                  _c("v-list-item-content", [
                                    _vm._v(
                                      " " +
                                        _vm._s("Пол: " + _vm.data.gender) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _vm.data.avatarUrl
                    ? _c("v-img", {
                        attrs: {
                          src: _vm.data.avatarUrl,
                          "max-width": 100,
                          "max-height": 100,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-expansion-panels",
                    [
                      _c(
                        "v-expansion-panel",
                        [
                          _c("v-expansion-panel-header", [_vm._v("Любимые")]),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _vm.data.favoriteAudioguides
                                ? _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "12" } }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              "Аудиогиды: " +
                                                _vm.data.favoriteAudioguides
                                                  .length
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.data.favoriteEvents
                                ? _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "12" } }, [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                "События: " +
                                                  _vm.data.favoriteEvents.length
                                              )
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.data.favoritePlaces
                                ? _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "12" } }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              "Места: " +
                                                _vm.data.favoritePlaces.length
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.data.favoriteRoutes
                                ? _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "12" } }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              "Маршруты: " +
                                                _vm.data.favoriteRoutes.length
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }